import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { Autocomplete, Box, Chip, TextField } from '@mui/material';

import { PromoMeta } from '~/services/PromoService';

import Spinner from '../Common/Spinner';

interface AllowedPaymentBrandSelectProps {
  selectedValues: Array<string>;
  control: Control<any>;
  allowedPaymentBrands: PromoMeta['promo_allowed_payment_brands'];
  isPromoMetaLoading: boolean;
}

function sortAllowedPaymentBrands(paymentBrands: PromoMeta['promo_allowed_payment_brands']) {
  return [...paymentBrands].sort((a, b) => a.label.localeCompare(b.label));
}

export default function AllowedPaymentBrandSelect({
  selectedValues,
  control,
  allowedPaymentBrands,
  isPromoMetaLoading,
}: AllowedPaymentBrandSelectProps) {
  if (isPromoMetaLoading) {
    return <Spinner />;
  }

  if (!allowedPaymentBrands || allowedPaymentBrands.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Controller
        key="allowed_payment_brands"
        name="allowed_payment_brands"
        control={control}
        render={({ field }) => (
          <Autocomplete
            {...field}
            multiple
            options={sortAllowedPaymentBrands(allowedPaymentBrands).map((paymentBrand) => paymentBrand.brand)}
            value={selectedValues}
            getOptionLabel={(option) =>
              allowedPaymentBrands.find((paymentBrand) => paymentBrand.brand === option)?.label || option
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={allowedPaymentBrands.find((paymentBrand) => paymentBrand.brand === option)?.label || option}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} fullWidth label="Allowed Payment Brands" variant="outlined" />
            )}
            onChange={(e: unknown, newValue: Array<string> | null) => {
              field.onChange(newValue);
            }}
          />
        )}
      />
    </Box>
  );
}
